import h from 'react-hyperscript';
import './ErrorMessage.scss';
import {subhead} from 'Components/Typography/Typography';

const ReportError = (props) => {
  const message = props.message;

  return (
    h('div', {
      className: 'error-message error-message--small',
    },
    h('div', null, h(typeof message === 'object' ? 'div' : subhead, {
      className: 'text--grey text--center',
    }, message))
    )
  );
};

export default ReportError;
